

const BannerLoginDimensions = [
    {
        height                                : 800,
	
        width                                 : 1200,
        

    },


];

export { BannerLoginDimensions };